var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUndo = function SvgUndo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19a.97.97 0 0 1-.713-.288A.97.97 0 0 1 7 18q0-.424.287-.712A.97.97 0 0 1 8 17h6.1q1.576 0 2.737-1Q18 15 18 13.5T16.837 11 14.1 10H7.8l1.9 1.9a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275L4.7 9.7a.9.9 0 0 1-.213-.325A1.1 1.1 0 0 1 4.425 9q0-.2.062-.375A.9.9 0 0 1 4.7 8.3l3.6-3.6a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L7.8 8h6.3q2.425 0 4.163 1.575Q20 11.15 20 13.5t-1.738 3.925Q16.526 19 14.1 19z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUndo);
export { ForwardRef as ReactComponent };